// Central place for localStorage keys that must survive a full
// `localStorage.clear()` at logout / "Change Company" (see
// clearLocalStorageExcept below). Keeping the key here (instead of duplicated
// as a string at every clear() call site) is what keeps them from drifting
// out of sync with useRecentCompanies.js.
export const RECENT_COMPANIES_STORAGE_KEY = 'thrana_recent_companies'

// The company a user picked on the company-selection page. Logout must clear
// these -- keeping a stale JWT's company implicitly selected let a user
// re-login as a different company while the UI/base URL still pointed at the
// previous one. Only company-selection itself should (re)write these keys.
export const SELECTED_COMPANY_STORAGE_KEYS = [
  'selectedCompanyId',
  'selectedCompanyName',
  'selectUrl',
  'totalCompanies',
]

// Logout and "Change Company" both wipe all of localStorage (auth tokens,
// redux-persist state, language preference, etc.) via localStorage.clear().
// That's intentional for session data, but it also silently erases
// unrelated, longer-lived preferences like recently-used companies. This
// preserves the given keys across that reset instead of losing them too.
export const clearLocalStorageExcept = (keysToKeep = []) => {
  const preserved = keysToKeep
    .map((key) => [key, localStorage.getItem(key)])
    .filter(([, value]) => value !== null)

  localStorage.clear()

  preserved.forEach(([key, value]) => localStorage.setItem(key, value))
}
